import React from 'react';
import { Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles<Theme>(({ spacing, palette }) => ({
  title: {
    fontSize: 20,
    marginBottom: spacing(3),
    textAlign: 'left',
    '&:after': {
      backgroundColor: palette.primary.main,
      content: "''",
      display: 'block',
      height: 2,
      margin: spacing(1, 0, 3),
      width: 40,
    },
  },
}));

export function ProfileDetailsTitle({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const classes = useStyles();

  return (
    <Typography className={classes.title} variant="h2">
      {children}
    </Typography>
  );
}
